import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import { dashWhite, dashYellow, groupWhite, groupYellow, pharmaYellow, pharmawhite } from "../../assets/icons/icons";

export default function PopupModal({ isOpen, setIsOpen, upcomingEvent }) {
  const navigate = useNavigate();

  return (
    <Modal
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={null}
      centered
      height={300}
    >
      <div className="grid grid-cols-3 rounded-xl overflow-hidden gap-3 h-[300px]">
        {/* All */}
        <HoverImage
          defaultImg={dashYellow}
          hoverImg={dashWhite}
          label="All"
          onClick={() => {
            setIsOpen(false);
            navigate(`/upcoming-events/details/${upcomingEvent?._id}?tab=3`);
          }}
        />

        {/* Sponsors */}
        <HoverImage
          defaultImg={groupYellow}
          hoverImg={groupWhite}
          label="Sponsors"
          onClick={() => {
            setIsOpen(false);
            navigate(`/upcoming-events/details/${upcomingEvent?._id}?tab=3`);
          }}
        />

        {/* Pharma/Biotech */}
        <HoverImage
          defaultImg={pharmaYellow}
          hoverImg={pharmawhite}
          label="Pharma/Biotech"
          onClick={() => {
            setIsOpen(false);
            navigate(`/upcoming-events/details/${upcomingEvent?._id}?tab=3`, {
              state: { selectedTab: "delegate" },
            });
          }}
        />
      </div>
    </Modal>
  );
}

function HoverImage({ defaultImg, hoverImg, label, onClick }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="text-yellow-500 px-6 py-4 flex flex-col items-center justify-center cursor-pointer bg-gray-100 hover:bg-yellow-500 hover:text-white transition-all duration-300"
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={isHovered ? hoverImg : defaultImg}
        alt={label}
        className="w-8 h-8 transition-all duration-300"
      />
      <p className="mt-2 font-bold transition-all duration-300">{label}</p>
    </div>
  );
}
